import { useGtm as useVueGtm } from "@gtm-support/vue-gtm"

export function useGtm() {
  return useVueGtm()
}
